/* @flow */
import React, { useContext } from "react";
import prefixStyles from "nx-components/utils/prefixStyles";
import Button from "nx-components/Button";
import { history, clearHistoryAndPush } from "nexia_mobile/history";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const styles = prefixStyles({
  outerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    overflowY: "auto",
  },
  innerWrapper: {
    margin: "1.5em",
    maxWidth: "25em",
    maxHeight: "100%",
  },
  fourOhFourWrapper: {
    margin: "1rem 0",
    fontSize: "3em",
    textAlign: "center",
  },
  textWrapper: {
    margin: "1rem 0",
    textAlign: "center",
  },
  pre: {
    margin: "1rem 0",
    padding: "0.5rem",
    fontFamily: "monospace",
    backgroundColor: "#f6f8fa",
    color: "#24292e",
    fontSize: "0.75em",
    overflowX: "auto",
  },
  codeComment: {
    color: "#6a737d",
  },
});

const NotFoundPage = () => {
  const languageContext = useContext(LanguageContext);
  const language = languageContext.localeSet.nexia_mobile.pages.NotFoundPage;

  return (
    <div style={styles.outerWrapper}>
      <div style={styles.innerWrapper}>
        <div style={styles.fourOhFourWrapper}>404</div>
        <div style={styles.textWrapper}>{language.pageNotFound}</div>
        {/* eslint-disable no-process-env */}
        {process.env.NODE_ENV === "production" ? null : (
          // eslint-enable no-process-env
          <pre style={styles.pre}>
            <code>
              <span style={styles.codeComment}>
                {"// history.location:\n\n"}
              </span>
              {JSON.stringify(history.location, null, 2)}
              <span style={styles.codeComment}>
                {"\n\n// (this box is not shown in prod)"}
              </span>
            </code>
          </pre>
        )}
        <Button
          full
          onTap={() => {
            if (history.entries.length > 1) {
              history.goBack();
            } else {
              clearHistoryAndPush("/");
            }
          }}
        >
          {language.goBack}
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/Pages/NotFoundPage.jsx